import React from "react";

function DashboardBreadcrumb(props) {
  return (
    <div
      className="shadow-sm border-b"
      style={{ padding: "12px 24px", backgroundColor: "#fff" }}
    >
      <div className="flex justify-between items-center h-8">
        <div className="flex items-center">{props.left}</div>
        <div className="flex items-center">{props.right}</div>
      </div>
    </div>
  );
}

export default DashboardBreadcrumb;
